var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgClosingAdministration(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 26.333c-2.667 0-5.25.417-7.667 1.2V32.7a1.68 1.68 0 01-.933 1.5 19.187 19.187 0 00-4.433 3.083c-.3.3-.717.467-1.167.467-.467 0-.883-.183-1.183-.483l-4.134-4.134c-.3-.283-.483-.7-.483-1.166 0-.467.183-.884.483-1.184C15.567 25.967 22.433 23 30 23s14.433 2.967 19.517 7.783c.3.3.483.717.483 1.184 0 .466-.183.883-.483 1.183l-4.134 4.133c-.3.3-.716.484-1.183.484a1.71 1.71 0 01-1.167-.467 18.78 18.78 0 00-4.45-3.083 1.66 1.66 0 01-.933-1.5V27.55c-2.4-.8-4.983-1.217-7.65-1.217z",
    fill: "#E3B05F"
  })));
}

export default SvgClosingAdministration;